























































import Vue from 'vue';
import { DemoClient, Demo } from '@/assets/src/clients/demo_client';
import { SearchParameter } from '@/assets/src/search_parameter';
import { toNiceDate } from '@/assets/src/utils/date';
import ROUTE_NAMES from '@/assets/src/routes';

import SimplePagination from '@/components/misc/SimplePagination.vue';

export default Vue.extend({
  name: 'UserDemoList',

  components: { SimplePagination },

  props: {
    cognitoId: {
      type: String,
      required: true,
    },
  },

  computed: {
    pageCount(): number {
      return Math.ceil(this.demos.length / this.itemsPerPage);
    },

    activeDemos(): Demo[] {
      return this.demos.filter((demo, i) => this.currentPage === Math.floor(i / this.itemsPerPage) + 1);
    },
  },

  methods: {
    toNiceDate,

    async listDemos() {
      this.demos = await this.demoClient.listUsersDemos(this.cognitoId, [
        new SearchParameter('account_group_demos', this.showAccountGroupDemos),
      ]);
    },
  },

  created() {
    this.listDemos();
  },

  data() {
    return {
      demos: [] as Demo[],
      demoClient: new DemoClient(),
      itemsPerPage: 10,
      currentPage: 1,

      showAccountGroupDemos: false,
    };
  },

  routeNames: ROUTE_NAMES,
});
